<template>
  <div>
    <h1>amin user reset password ...</h1>
  </div>
</template>

<script>

  export default {
    name: "ResetPassword",

    data() {
      return {
      };
    },

    created() {
    },

    methods: {
      initialize(){
         
      },

      loging() {
        
      }
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    }
  };
</script>

<style scoped></style>
